import type { EligibilityFormData } from '../types'
import type { EligibilityFieldErrors } from './types'

type UseEligibilityFormControlsArgs = {
  clearFieldError: (field: keyof EligibilityFieldErrors) => void
  formData: EligibilityFormData
  isSubmitting: boolean
  isUnder18: boolean
  updateFormData: (data: Partial<EligibilityFormData>) => void
}

export function useEligibilityFormControls({
  clearFieldError,
  formData,
  isSubmitting,
  isUnder18,
  updateFormData
}: UseEligibilityFormControlsArgs) {
  const handleCitizenshipChange = (value: boolean) => {
    clearFieldError('isCitizen')
    updateFormData({ isCitizen: value })
  }

  const handleGenderChange = (value: string) => {
    clearFieldError('gender')
    updateFormData({ gender: value })
  }

  const handleEthnicityChange = (value: string) => {
    clearFieldError('ethnicity')
    updateFormData({ ethnicity: value })
  }

  const handleEducationLevelChange = (value: string) => {
    clearFieldError('educationLevel')
    updateFormData({ educationLevel: value })
  }

  const isContinueDisabled =
    isSubmitting ||
    isUnder18 ||
    !formData.dateOfBirth ||
    formData.isCitizen === null ||
    !formData.gender ||
    !formData.ethnicity ||
    !formData.educationLevel

  return {
    handleCitizenshipChange,
    handleEducationLevelChange,
    handleEthnicityChange,
    handleGenderChange,
    isContinueDisabled
  }
}
